import   React                               ,
       { useState                            } from 'react';

import   classNames                            from 'classnames';

import   styles                                from './BroadcastingChannelCategoryManager.module.scss';

import   BroadcastingChannelCategoryCreation   from './BroadcastingChannelCategoryCreation';
import   BroadcastingChannelCategoryList       from './BroadcastingChannelCategoryList';

import { BroadcastingChannelCategory }         from '../../../dataTypes/broadcastingManagment/types';

export interface BroadcastingChannelCategoryManagerProps {
  onCategoryCreated?: (createdCategory: BroadcastingChannelCategory) => void;
  /** Ouvert dans une fenêtre (Box) : la hauteur colle au contenu. */
  embedded?: boolean;
  /** Rendu à l'intérieur d'une autre page (BroadcastingChannelList) qui porte déjà le fond et les marges. */
  nested?: boolean;
  /** Si fourni, affiche le bouton de retour "Chaînes" en haut à droite. */
  onBackToChannels?: () => void;
}

export const BroadcastingChannelCategoryManager = ({ onCategoryCreated, embedded = false, nested = false, onBackToChannels }: BroadcastingChannelCategoryManagerProps = {}) => {

  const [ refreshList                        , setRefreshList                        ] = useState<boolean>(false);
  const [ broadcastingChannelCategoriesCount , setBroadcastingChannelCategoriesCount ] = useState<number>(0);

  const handleBroadcastingChannelCategoryCreation = (createdCategory?: BroadcastingChannelCategory) => {
    setRefreshList((prevState) => !prevState);
    if (createdCategory && onCategoryCreated) { onCategoryCreated(createdCategory); }
  };

  const handleBroadcastingChannelCategoryDeletion = () => {
    setRefreshList((prevState) => !prevState);
  };

  const handleBroadcastingChannelCategoriesCount = (count: number) => {
    setBroadcastingChannelCategoriesCount(count);
  };

  return (
    <div className={classNames(styles.root, embedded && styles.rootEmbedded, nested && styles.rootNested)}>

      <div className={classNames(styles.pageHeader)}>
        <div className={classNames(styles.pageHeaderText)}>
          <h1 className={classNames(styles.pageTitle)}>Catégories de chaînes</h1>
          <p className={classNames(styles.pageSubtitle)}>Organisez et gérez les catégories de chaînes diffusées.</p>
        </div>
        {
          onBackToChannels &&
          <button className={classNames(styles.btn, styles.btnPrimary)}
                  onClick={onBackToChannels}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            Chaînes
          </button>
        }
      </div>

      <div className={classNames(styles.contain)}>
        <div className={classNames(styles.creationPart)}>
          <BroadcastingChannelCategoryCreation
            onCreate      = {handleBroadcastingChannelCategoryCreation}
            numCategories = {broadcastingChannelCategoriesCount}
          />
        </div>
        <div className={classNames(styles.listPart)}>
          <BroadcastingChannelCategoryList
            refresh             = {refreshList}
            onCategoriesFetched = {handleBroadcastingChannelCategoriesCount}
            onDelete            = {handleBroadcastingChannelCategoryDeletion}
          />
        </div>
      </div>
    </div>
  );
};

export default BroadcastingChannelCategoryManager;
